@if (showLabel && (question?.question_prompt || question?.question_copy)) {
  <label class="form-group__label">
    {{useQuestionCopy ? question?.question_copy : question?.question_prompt ? question?.question_prompt : question?.email_version}}
  </label>
}

<div class="row row--sm">
  @for (option of items; track option; let i = $index) {
    <div class="col-sm" [ngClass]="{'mt-15 mt-sm-0': i !== 0}">
      <label class="custom-input custom-input--radio custom-input--pill" [ngClass]="{'disable-readonly': readOnly}">
        <input
          type="radio"
        [checked]="option?.answer === question?.answer
        || option === selectedOption || i === 0"
          [name]="uniqueControlName"
          [value]="option?.answer ? option?.answer : option"
          (click)="checkRadio(option?.answer ? option?.answer : option)">
          <span class="custom-input__indi"></span>
          <span class="custom-input__label">{{option?.answer ? option?.answer : option}}</span>
        </label>
      </div>
    }
  </div>
